import request from "./request";
/**
 * 查询发布队列/发布历史数据
 * @param pageSize 页数大小
 * @param startSendTime  开始排文
 * @param endSendTime 结束排文时间
 * @param content 贴文信息里的文本信息
 * @param link 链接
 * @param pageName 专页名称
 * @param sendType 发送类型 1-链接 2-图片 3-文本
 * @param type 查询类型 1-发布队列 2-发布历史
 * @param pageNumber 当前页数
 * @param pageSize 页数大小
 */
export default async function getSendPage(params = {}) {
  const defaultParams = {
    type: 1,
    pageNumber: 1,
    pageSize: 10,
  };
  return await request.get("/spin/dataSend/getSendPage", {
    params: { ...defaultParams, ...params },
  });
}
